module.exports = __webpack_public_path__ + "static/media/ZT2.6cf90335.jpg";